import React from "react";
import { tw } from "@careinfo/tailwind";
import Card from "../Card";
const InvoiceSkeleton = () => {
  return (
    <>
      <div className={tw`w-full px-4  mx-auto`}>
        <div className={tw` flex gap-x-8 justify-end mb-6`}>
          {Array.from({ length: 3 }).map((_, index) => {
            return (
              <div
                key={index}
                className={tw`w-24 h-10 bg-gray-200 rounded-lg animate-pulse`}
              ></div>
            );
          })}
        </div>

        {/* Card */}
        <div
          className={tw`flex flex-col p-4 sm:p-10 bg-white shadow-md rounded-xl `}
        >
          {/* Grid */}
          <div className={tw`flex justify-between`}>
            <div className={tw` w-32 h-20 animate-pulse bg-gray-200`}></div>
            {/* Col */}

            <div className={tw`w-32 h-20 animate-pulse bg-gray-200`}></div>
            {/* Col */}
          </div>
          {/* End Grid */}

          {/* Grid */}
          <div className={tw`mt-8 text-sm flex justify-between  gap-3`}>
            <div>
              {Array.from({ length: 7 }).map((_, index) => {
                return (
                  <div
                    key={index}
                    className={tw`w-40 h-4 bg-gray-200 mb-2 animate-pulse`}
                  ></div>
                );
              })}
            </div>
            <div className="flex flex-col  ">
              {Array.from({ length: 7 }).map((_, index) => {
                return (
                  <div
                    key={index}
                    className={tw`w-40 h-4 bg-gray-200 mb-2 animate-pulse`}
                  ></div>
                );
              })}
            </div>
          </div>
          <table
            className={tw`mt-6 border border-gray-400 p-4 rounded-lg  space-y-4 `}
          >
            <thead>
              <tr
                className={tw`text-center h-10 bg-gray-200 animate-pulse border-b border-gray-400 `}
              >
                {Array.from({ length: 7 }).map((_, index) => {
                  return (
                    <div
                      key={index}
                      className={tw` w-full rounded-xl animate-pulse`}
                    ></div>
                  );
                })}
              </tr>
            </thead>

            <tbody>
              <tr
                className={tw`text-center h-10 bg-gray-200 animate-pulse border-b mx-1 border-gray-400 `}
              >
                {Array.from({ length: 7 }).map((_, index) => {
                  return (
                    <div
                      key={index}
                      className={tw`h-10 w-full rounded-xl animate-pulse`}
                    ></div>
                  );
                })}
              </tr>
            </tbody>
          </table>
          {/* End Table */}

          {/* Flex */}
          <div className={tw`mt-8 flex justify-end`}>
            <div className={tw`w-[50%] flex justify-between `}>
              <div className="flex flex-col  ">
                {Array.from({ length: 7 }).map((_, index) => {
                  return (
                    <div
                      key={index}
                      className={tw`w-32 h-4 bg-gray-200 mb-2 animate-pulse`}
                    ></div>
                  );
                })}
              </div>
              <div className="flex flex-col  ">
                {Array.from({ length: 7 }).map((_, index) => {
                  return (
                    <div
                      key={index}
                      className={tw`w-32 h-4 bg-gray-200 mb-2 animate-pulse`}
                    ></div>
                  );
                })}
              </div>
            </div>
          </div>
          {/* End Flex */}
          <div className={tw`mt-6 sm:mt-12`}>
            <h4
              className={tw`text-lg font-semibold text-gray-500 w-20 mb-2  h-3 bg-gray-200 animate-pulse`}
            ></h4>
            <p className={tw`w-full h-3 bg-gray-200 animate-pulse`}></p>
            <div className={tw`mt-2`}>
              <p
                className={tw`block h-3 bg-gray-200 animate-pulse text-sm font-medium text-gray-500 `}
              ></p>
            </div>
          </div>
          <p
            className={tw`mt-5  h-3 bg-gray-200 animate-pulse text-sm text-gray-500 mx-auto`}
          ></p>
        </div>
      </div>
    </>
  );
};

export default InvoiceSkeleton;
